import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { AddEditLocationFormPayload } from "modules/DMSv3/Settings/components";

const FormHelper = createFormHelper<AddEditLocationFormPayload>();

export const AutoflexConfigSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_autoflex_username", "Autoflex username")} </label>
            <FormHelper.Field.Input name="autoflex_username" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_autoflex_password", "Autoflex password")} </label>
            <FormHelper.Field.Input name="autoflex_password" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>
    </>
  );
};
